import React, { useRef, useState, useEffect } from 'react';
import "./CustomVideoPlayer.css";
import config from '../../../../../../application/config/config';
import { useParams } from 'react-router-dom';
import { getUserSession } from '../../../../../util/core/Session';
import Fetch from '../../../../../util/core/Fetch';

const CustomVideoPlayer = (props) => {

  const pathBackEnd = 'core/tutorial/';
  const paths = {
    endpoint: config.endpoints.backend + pathBackEnd + 'getCurrentProgress',
  };

  const params = useParams();
  const session = getUserSession();

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFirstPlay, setIsFirstPlay] = useState(true);
  const finalProgressRef = useRef(0);

  const togglePlayPause = (e) => {
    e.preventDefault();

    if (isLoading) {
      return;
    }

    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();

      if (isFirstPlay) {
        setIsFirstPlay(false);
      }
      
    }
    
    setIsPlaying(!isPlaying);
  };
  
  const updateProgress = () => {
    const currentProgress = videoRef.current.currentTime;
    finalProgressRef.current = currentProgress;
  };

  const controller = new AbortController();

  async function getCurrentProgress() {
    setIsLoading(true);
    const { current_progress } = await Fetch.post(paths.endpoint, { core_video_id: params.id, core_user_id: session.user.id });
    videoRef.current.addEventListener('loadedmetadata', () => {
      videoRef.current.currentTime = current_progress;
      controller.abort();
    });
    setIsLoading(false);
  }

  useEffect(() => {
    getCurrentProgress();
  },[]);
  
  useEffect(() => {
    const handleFirstPlay = () => {
      if (isFirstPlay) {
        props.logFunction();
        setIsFirstPlay(false);
      }
    };

    const videoElement = videoRef.current;
    videoElement.addEventListener('play', handleFirstPlay);

    return () => {
      videoElement.removeEventListener('play', handleFirstPlay);
      props.updateProgress(finalProgressRef.current);
    };
  }, [isFirstPlay]);

  return (
    <div className="video-player">
      {isLoading && <>Carregando vídeo...</>}
      <video
        ref={videoRef}
        onTimeUpdate={updateProgress}
        onClick={togglePlayPause}
        controls
      >
        <source src={props.src} type={`video/${props.fileExtension}`} />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default CustomVideoPlayer;